import { useContext } from "react";

import { RoutesContext } from "@Libs/Router/Contexts/RoutesContext";

export const useRoutes = () => {
  return useContext(RoutesContext);
};
